import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchArticleCategories as fetchArticleCategoriesClient } from '../clients/kb-api.v3';
import Raven from 'raven-js';
export const fetchArticleCategories = createAsyncThunk('articles/fetchArticleCategories', knowledgeBaseId => fetchArticleCategoriesClient(knowledgeBaseId).then(response => response).catch(error => {
  Raven.captureException(error);
  throw error;
}));